import { legacy_createStore} from 'redux'
import {actiuveSectionDetctor} from './reducers';

export const store = legacy_createStore(actiuveSectionDetctor);


